// Turbo does not fire DOMContentLoaded on a normal navigation - it replaces the body of a document
// that is already loaded - so reaching Sign Up by following a link left this unbound. The button
// then submitted the form with an empty recaptcha_token, which Users::RegistrationsController
// scores as it finds it, and the registration was refused. turbo:load covers the Turbo visits;
// DOMContentLoaded and the immediate call cover a first load whichever way the pack lands.
function initializeRecaptcha() {
    const form = document.getElementById('new_user')
    const submitButton = document.getElementById('new_user_submit')
    const recaptchaToken = document.getElementById('recaptcha_token')
    // Also a guard the old version did not have: without the null check this threw on any page the
    // pack was appended to that had no sign-up form on it.
    if (!form || !submitButton || !recaptchaToken || submitButton.dataset.recaptchaBound) return

    submitButton.dataset.recaptchaBound = 'true'
    submitButton.addEventListener('click', (event) => {
        event.preventDefault();
        grecaptcha.enterprise.ready(async () => {
            recaptchaToken.value = await grecaptcha.enterprise.execute('6LfwcmsqAAAAAGYZ1Y_-qvPJzxkbtkt6so7tCCN8', {action: 'signup'});
            form.submit()
        });
    })
}

document.addEventListener('turbo:load', initializeRecaptcha)
document.addEventListener('DOMContentLoaded', initializeRecaptcha)
initializeRecaptcha()
